"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Subheading = exports.Divider = exports.LabelValue = exports.LabelValueGridHeader = exports.LabelValueGrid = exports.LabelValueGridContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
require("./LabelValueGrid.css");
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var date_fns_1 = require("date-fns");
var locale_1 = require("../../utils/locale");
var MDIcon_1 = require("../../components/MDIcon");
var getDisplayValue_1 = require("../../utils/getDisplayValue");
var Stack_1 = require("../../components/Stack");
var Row_1 = require("../../components/Row");
exports.LabelValueGridContext = react_1.default.createContext({
  dateFormatFn: function (d) {
    return d.toString();
  },
  noValue: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
    inline: true,
    icon: "null"
  })
});
var LabelValueGrid = function (_a) {
  var dateFormat = _a.dateFormat,
    _b = _a.dateLocale,
    dateLocale = _b === void 0 ? "en" : _b,
    _c = _a.noValue,
    noValue = _c === void 0 ? (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
      inline: true,
      icon: "null"
    }) : _c,
    children = _a.children,
    className = _a.className,
    title = _a.title,
    subtitle = _a.subtitle,
    actions = _a.actions,
    footer = _a.footer,
    restProps = __rest(_a, ["dateFormat", "dateLocale", "noValue", "children", "className", "title", "subtitle", "actions", "footer"]);
  var dateFormatFn = function (value) {
    return (0, date_fns_1.format)(value, dateFormat !== null && dateFormat !== void 0 ? dateFormat : locale_1.languageToDateFormat[dateLocale], {
      locale: (0, locale_1.getLocale)(dateLocale)
    });
  };
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    role: "grid",
    className: (0, classnames_1.default)("vsx-label-value-grid", className)
  }, restProps, {
    children: [(0, jsx_runtime_1.jsx)(exports.LabelValueGridHeader, {
      title: title,
      subtitle: subtitle,
      actions: actions
    }), (0, jsx_runtime_1.jsx)(exports.LabelValueGridContext.Provider, __assign({
      value: {
        dateFormatFn: dateFormatFn,
        noValue: noValue
      }
    }, {
      children: children
    })), footer && (0, jsx_runtime_1.jsx)("div", __assign({
      className: "vsx-label-value-grid-footer"
    }, {
      children: footer
    }))]
  }));
};
exports.LabelValueGrid = LabelValueGrid;
var LabelValueGridHeader = function (_a) {
  var title = _a.title,
    subtitle = _a.subtitle,
    actions = _a.actions;
  var isEmpty = !title && !subtitle && !actions;
  return isEmpty ? null : (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
    className: "vsx-label-value-grid-header",
    justify: "space-between",
    gap: "medium"
  }, {
    children: [(0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
      gap: "medium-small",
      paddingBottom: "medium-large"
    }, {
      children: [(0, jsx_runtime_1.jsx)("div", __assign({
        className: "vsx-label-value-grid-title"
      }, {
        children: title
      })), (0, jsx_runtime_1.jsx)("div", __assign({
        className: "vsx-label-value-grid-subtitle"
      }, {
        children: subtitle
      }))]
    })), (0, jsx_runtime_1.jsx)("div", __assign({
      className: "vsx-label-value-grid-actions"
    }, {
      children: actions
    }))]
  }));
};
exports.LabelValueGridHeader = LabelValueGridHeader;
var LabelValue = function (_a) {
  var label = _a.label,
    value = _a.value;
  var _b = (0, react_1.useContext)(exports.LabelValueGridContext),
    dateFormatFn = _b.dateFormatFn,
    noValue = _b.noValue;
  var displayValue = (0, getDisplayValue_1.getDisplayValue)(value, dateFormatFn, noValue);
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    role: "row",
    className: "vsx-label-value-grid-row"
  }, {
    children: [(0, jsx_runtime_1.jsx)("div", __assign({
      role: "gridcell",
      className: "vsx-label-value-grid-label"
    }, {
      children: label
    })), (0, jsx_runtime_1.jsx)("div", __assign({
      role: "gridcell",
      className: "vsx-label-value-grid-value"
    }, {
      children: displayValue
    }))]
  }));
};
exports.LabelValue = LabelValue;
var Divider = function () {
  return (0, jsx_runtime_1.jsx)("div", {
    role: "separator",
    className: "vsx-label-value-grid-divider"
  });
};
exports.Divider = Divider;
var Subheading = function (_a) {
  var className = _a.className,
    heading = _a.heading,
    children = _a.children,
    restProps = __rest(_a, ["className", "heading", "children"]);
  return (0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
    gap: "medium",
    className: (0, classnames_1.default)("vsx-label-value-grid-subheading", className),
    paddingBottom: "small"
  }, restProps, {
    children: [heading && (0, jsx_runtime_1.jsx)("div", __assign({
      className: "vsx-label-value-grid-subheading-heading"
    }, {
      children: heading
    })), children && (0, jsx_runtime_1.jsx)("div", __assign({
      className: "vsx-label-value-grid-subheading-description"
    }, {
      children: children
    }))]
  }));
};
exports.Subheading = Subheading;